import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'
import { get } from 'lodash'
import I18n from 'I18n'

ButtonDownload.propTypes = {
  type: PropTypes.string.isRequired,
  constructorFunctions: PropTypes.object.isRequired,
  permit: PropTypes.object.isRequired,
  isDownloading: PropTypes.bool.isRequired,
  withinDropdown: PropTypes.bool
}

export default function ButtonDownload({
  type,
  permit,
  isDownloading,
  constructorFunctions,
  withinDropdown = false
}) {
  return (
    <Button
      className={withinDropdown ? 'btn-within-dropdown' : ''}
      loading={isDownloading}
      onClick={e => {
        e.stopPropagation() // necessary to prevent the click event from bubbling up when use in a dropdown's table rown

        switch (type) {
          case 'firePermit':
            get(constructorFunctions, 'handleRevisionPDF')(
              'firePermit',
              get(permit, 'id'),
              get(permit, 'revision')
            )
            break
          case 'searchPermit':
            get(constructorFunctions, 'handleRevisionPDF')(
              'searchPermit',
              get(permit, 'id'),
              get(permit, 'revision')
            )
            break
          case 'capacityPermit':
            get(constructorFunctions, 'handleRevisionPDF')(
              'capacityPermit',
              get(permit, 'id'),
              get(permit, 'revision')
            )
            break
          case 'cleaningPermit':
            get(constructorFunctions, 'handleRevisionPDF')(
              'cleaningPermit',
              get(permit, 'id'),
              get(permit, 'revision')
            )
            break
          default:
            get(constructorFunctions, 'handleRevisionPDF')(
              'permit',
              get(permit, 'id'),
              get(permit, 'revision')
            )
            break
        }
      }}
      icon='download'
      type='ghost'
    >
      {I18n.t('pages.permits.actions.display')}
    </Button>
  )
}
